import { useEffect, useState, useCallback } from 'react';
import * as language from '../constants/languages';
import SpinnerLoader from '../components/SpinnerLoader';
import HeaderCommon from '../components/HeaderCommon';
import { useNavigate } from 'react-router-dom';
import Trash from '../assets/svg/delete.svg'
import Plus from '../assets/svg/plus.svg'
import Minus from '../assets/svg/minus.svg'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import '../styles/CartPage.css'
import { Snackbar } from '@mui/material';
import { getProductDetails } from '../services/services';
import { Spinner } from "react-bootstrap"

export default function CartPage() {
    const navigate = useNavigate()
    let mediaQueryList = window.matchMedia("(min-width: 992px)");

    const branchId = localStorage.getItem('storeId');

    const [isLoading, setisLoading] = useState(true)
    const [cartItems, setcartItems] = useState([])
    const [totalValue, settotalValue] = useState(0)
    const [decimalPlaces, setdecimalPlaces] = useState(2)
    const [outOfStock, setoutOfStock] = useState(false)
    const [currencySymbol, setcurrencySymbol] = useState()
    const [itemCount, setitemCount] = useState()
    const [snackopen, setsnackopen] = useState(false)
    const [message, setmessage] = useState('')
    const [isLargeDisplay, setisLargeDisplay] = useState(mediaQueryList.matches)
    const [isRefetching, setIsRefetching] = useState(false);
    const [currentlyFetchingId, setCurrentlyFetchingId] = useState()
    useEffect(() => {

        window.addEventListener('cartitemremoved', getCartItemsFn)
        // checkLogin();
        setisLoading(true)
        getCompanyInfo();
        getCartItemsFn();
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener("change", checkDevice)
        }
        else {
            mediaQueryList.addListener(checkDevice)
        }
        return () => {
            if (mediaQueryList.addEventListener) {
                mediaQueryList.removeEventListener("change", checkDevice)
            } else {
                mediaQueryList.removeListener(checkDevice)
            }
            window.removeEventListener('cartitemremoved', getCartItemsFn);
        }
    }, [])

    //check if mobile
    function checkDevice(mql) {
        setisLargeDisplay(mql.matches)
    }

    //get sotre name
    async function getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')

        if (value === null || value === undefined) {
            setcurrencySymbol("")
        } else {
            const companyInfo = JSON.parse(value);
            setcurrencySymbol(companyInfo.currencySymbol)
            setdecimalPlaces(companyInfo.decimalValue)
        }

    }

    // get cart items
    async function getCartItemsFn() {
        let cartitems
        let totalvalue = 0;
        let cart = await localStorage.getItem('cartItems');
        if (!cart) {
            let items = {
                customerCartItems: [],
                branchId: parseInt(branchId),
                companyId: language.companyidValue
            }
            setcartItems(items)
            setisLoading(false)

        } else {

            cartitems = JSON.parse(cart);
            setcartItems(cartitems)
            setisLoading(false)
            setitemCount(cartitems.customerCartItems.length)
        }
        if (!cart) {
            return
        }

        for (let i = 0; i < cartitems?.customerCartItems?.length; i++) {

            if (cartitems.customerCartItems[i].product.oRate != null) {
                if (cartitems.customerCartItems[i].product.incrementValue == null) {
                    totalvalue = (totalvalue + (cartitems.customerCartItems[i].qty * cartitems.customerCartItems[i].product.oRate))

                } else {
                    totalvalue = (totalvalue + ((cartitems.customerCartItems[i].qty * cartitems.customerCartItems[i].product.oRate)))

                }
            } else {
                if (cartitems.customerCartItems[i].product.incrementValue == null) {
                    totalvalue = (totalvalue + (cartitems.customerCartItems[i].qty * cartitems.customerCartItems[i].product.sRate))

                } else {
                    totalvalue = (totalvalue + ((cartitems.customerCartItems[i].qty * cartitems.customerCartItems[i].product.sRate)))

                }
            }
            if (outOfStock == false) {
                if (cartitems.customerCartItems[i].product.isStockAvailable == false) {
                    //out of stock items
                    setoutOfStock(true)

                } else {

                    setoutOfStock(false)

                }
            }
        }
        settotalValue(totalvalue)


    }

    async function reCalculateCartTotal(cart) {

        let total = 0;
        setoutOfStock(false)

        // let cart = storage.getString('cartItems');
        if (!cart) { return }
        // let cartItems = JSON.parse(cart);
        let cartItems = cart;

        for (let i = 0; i < cartItems?.customerCartItems?.length; i++) {

            if (cartItems.customerCartItems[i].product.oRate != null) {
                if (cartItems.customerCartItems[i].product.incrementValue == null) {
                    total = total + (cartItems.customerCartItems[i].qty * cartItems.customerCartItems[i].product.oRate)

                } else {
                    total = total + (cartItems.customerCartItems[i].qty * cartItems.customerCartItems[i].product.oRate)
                }
            } else {
                if (cartItems.customerCartItems[i].product.incrementValue == null) {
                    total = total + (cartItems.customerCartItems[i].qty * cartItems.customerCartItems[i].product.sRate)

                } else {
                    total = total + (cartItems.customerCartItems[i].qty * cartItems.customerCartItems[i].product.sRate)
                }
            }
            if (outOfStock == false) {
                if (cartItems.customerCartItems[i].product.isStockAvailable == false) {
                    //out of stock items
                    setoutOfStock(true)


                } else {
                    setoutOfStock(false)

                }
            }

        }
        settotalValue(total)

    }

    const reFetchProductDetails = useCallback(async (product_id) => {
        setCurrentlyFetchingId(product_id)
        try {
            const token = localStorage.getItem('access_token');
            const productDetails = await getProductDetails(language.companyidValue, product_id, branchId, token);
            if (productDetails.status === 'success') {
                return (productDetails.data.stock)
            }
            else {
                throw new Error
            }
        } catch (error) {
            throw error
        }
    }, []);


    // quantity select
    async function quantityPressed(itemIndex, valueAction, productPrice, productId, cartItem, e) {
        e.stopPropagation()
        let incrementValue
        if (cartItem.product.incrementValue == null) {
            incrementValue = 1
        } else {
            incrementValue = cartItem.product.incrementValue
        }
        // if (['value_' + itemIndex] == null) {
        if (valueAction === 'increment') {
            setIsRefetching(true)
            const currentStock = await reFetchProductDetails(cartItem.product.productId)
            if (!currentStock && currentStock !== 0) {
                setIsRefetching(false)
                return
            }
            const qtyToEvaluate = (valueAction === 'increment' ? cartItem.qty + incrementValue : cartItem.qty - incrementValue)
            if (cartItem.product.allowNegativeStock == true || qtyToEvaluate <= (currentStock ?? 0)) {
                cartAddRemove(productId, 1, cartItem.product.categoryId, cartItem.product.brandId, cartItem, itemIndex) //add qny to cart
            }
            else {
                showToastMessage(language.cartAddRemove);
                setIsRefetching(false)
                return
            }
        } else {
            // if (['quantity_' + itemIndex] != incrementValue) {
            if (cartItem.qty != incrementValue) {
                cartAddRemove(productId, 0, cartItem.product.categoryId, cartItem.product.brandId, cartItem, itemIndex)
            } //reduce qny to cart
            // }
            else {
                removeItem(cartItem.productId, cartItem, e)
            }
        }
        // }
        setIsRefetching(false)


    }

    async function cartAddRemove(id, action, cateId, brandId, cartItem, itemIndex) {

        let incrementValue = 0
        if (cartItem.product.incrementValue == null) {
            incrementValue = 1
        } else {
            incrementValue = cartItem.product.incrementValue
        }
        if (action == 1) { //add to cart

            if (cartItem.product.isStockAvailable == true) {

                let cartItemsJson = localStorage.getItem('cartItems');
                let cartitems
                if (cartItemsJson == null) {
                    cartitems = {
                        customerCartItems: [
                        ],
                        branchId: parseInt(branchId),
                        companyId: language.companyidValue
                    }
                } else {
                    cartitems = JSON.parse(cartItemsJson);
                }


                const elementsIndex = cartitems.customerCartItems.findIndex(element => element.product.productId == cartItem.product.productId)
                if (branchId == cartitems.branchId) {
                    var requiredQty = elementsIndex == -1 ? incrementValue : (cartitems.customerCartItems[elementsIndex].qty + incrementValue);
                    if (cartItem.product.allowNegativeStock == true || requiredQty <= (cartItem.product.stock ?? 0)) {
                        if (elementsIndex == -1) {
                            cartitems.customerCartItems = [
                                ...cartitems.customerCartItems,
                                {
                                    product: cartItem.product,
                                    qty: incrementValue,
                                    variantId: null
                                }
                            ]
                        } else {
                            cartitems.customerCartItems[elementsIndex] = {
                                product: cartitems.customerCartItems[elementsIndex].product,
                                qty: cartitems.customerCartItems[elementsIndex].qty + incrementValue,
                                variantId: cartitems.customerCartItems[elementsIndex].variantId
                            }
                        }
                        localStorage.setItem('cartItems', JSON.stringify(cartitems))

                        reCalculateCartTotal(cartitems);
                        setcartItems(cartitems)
                        const event = new CustomEvent('productQtyChange');
                        window.dispatchEvent(event)

                        // showToastMessage(language.itemAddedTocart);
                    } else {
                        showToastMessage(language.cartAddRemove);
                    }


                } else {

                    showToastMessage(language.anotherBranch);
                }

            } else {
                showToastMessage(language.cartAddRemove);
            }


        } else { //reduce from cart

            let cartItemsJson = localStorage.getItem('cartItems');
            let cartitems = {}
            if (!cartItemsJson) {
                cartitems = {
                    customerCartItems: [
                    ],
                    branchId: parseInt(branchId),
                    companyId: language.companyidValue
                }
            } else {
                cartitems = JSON.parse(cartItemsJson);
            }

            if (branchId == cartitems.branchId) {

                const elementsIndex = cartitems.customerCartItems.findIndex(element => element.product.productId == cartItem.product.productId);
                if (elementsIndex > -1) {
                    var requiredQty = elementsIndex == -1 ? incrementValue : (cartitems.customerCartItems[elementsIndex].qty - incrementValue);
                    if (requiredQty > 0) {
                        cartitems.customerCartItems[elementsIndex] = {
                            product: cartitems.customerCartItems[elementsIndex].product,
                            qty: (requiredQty < 0 ? 0 : requiredQty),
                            variantId: cartitems.customerCartItems[elementsIndex].variantId,
                        }
                        localStorage.setItem('cartItems', JSON.stringify(cartitems));

                        reCalculateCartTotal(cartitems);
                        setcartItems(cartitems)
                        const event = new CustomEvent('productQtyChange');
                        window.dispatchEvent(event)

                        // showToastMessage(language.itemReducedFromCart);
                    } else {


                    }
                } else {


                }

            } else {

                showToastMessage(language.anotherBranch);
            }

        }
    }



    // remove item from cart
    async function removeItem(id, cartItem, e) {
        e.stopPropagation()
        const cart = localStorage.getItem('cartItems')
        const cartitems = JSON.parse(cart);
        const elementsIndex = cartitems.customerCartItems.findIndex(element => element.product.productId == cartItem.product.productId);
        cartitems.customerCartItems.splice(elementsIndex, 1);
        if (cartitems?.customerCartItems?.length == 0) {
            localStorage.removeItem('cartItems')
        }
        else {
            localStorage.setItem('cartItems', JSON.stringify(cartitems));
        }
        setitemCount(cartitems?.customerCartItems?.length)
        reCalculateCartTotal(cartitems);
        setcartItems(cartitems)
        const event = new CustomEvent('productQtyChange');
        window.dispatchEvent(event)

        showToastMessage(language.removedFromCart);

    }

    const showToastMessage = (message) => {
        setmessage(message)
        setsnackopen(true)
    }
    const onSnackClose = () => {
        setsnackopen(false)

    }

    const action = (
        <>

            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setsnackopen(false)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    return (

        <div className='cart-page-container'>
            <HeaderCommon />
            {
                isLoading == true ?
                    <SpinnerLoader />
                    :
                    isLargeDisplay ?
                        cartItems?.customerCartItems?.length == 0 ?
                            <div style={{ flex: 1, alignItems: 'center', height: '10rem', display: 'flex', justifyContent: 'center' }}>
                                <p>{language.noItmsLabe}</p>
                            </div>
                            :
                            <table >
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th >Description</th>
                                        <th >Quantity</th>
                                        <th >Total</th>
                                        <th >Remove</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cartItems.customerCartItems.map((cartItem, index) => {
                                            const prodId = cartItem.product?.productId || cartItem.productId;
                                            return (
                                                <tr
                                                    style={{
                                                        borderBottomWidth: index == cartItems?.customerCartItems?.length - 1 ? 0 : 0.4,
                                                        borderColor: '#70707030',
                                                        borderBottomStyle: 'solid',
                                                        cursor: prodId ? 'pointer' : 'default'
                                                    }}
                                                    key={index}
                                                    onClick={() => {
                                                        if (prodId) {
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                            navigate(`/Productdetails/${prodId}`);
                                                        }
                                                    }}
                                                >
                                                    <td style={{ paddingBlock: '2rem' }}>
                                                        <div>
                                                            <img src={cartItem.product.tblProductImages ? cartItem.product.tblProductImages[0].image : null} width={130} height={100} alt="" />
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <div>
                                                            <p style={{ fontFamily: 'Poppins-Regular', color: '#9E9E9E', fontSize: 9 }}>{cartItem.product.brand?.brandName}</p>
                                                            <p className="cart-product-title-link" style={{ fontFamily: 'Poppins-Regular', margin: '0 0 2px 0', fontWeight: 500 }}>{cartItem.product?.productName}</p>
                                                        <p style={{ fontFamily: 'Poppins-Regular', fontSize: 12, }}>{cartItem.product.regionalLanguage == null ? "" : cartItem.product.regionalLanguage}</p>

                                                        {
                                                            cartItem.product.isStockAvailable == false ?
                                                                <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 12, color: language.red, marginInline: 0 }}>{language.outStockLabel}</p>
                                                                :
                                                                <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 12, color: language.green, margin: 0, }}>{language.inStockLabel}</p>
                                                        }
                                                    </div>

                                                </td>
                                                <td  >

                                                    {
                                                        cartItem.product.isStockAvailable == false ?
                                                            null
                                                            :

                                                            <div className='cart-large-quantitywrapper'>

                                                                <div onClick={(e) => quantityPressed((index + 1), 'decrement', cartItem.product.sRate, cartItem.productId, cartItem, e)} >
                                                                    <img src={Minus} size={14} />

                                                                </div>

                                                                <div style={{
                                                                    marginHorizontal: 10,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    alignSelf: 'center',
                                                                    fontSize: 12,
                                                                    textAlign: "center"
                                                                }}>
                                                                    {
                                                                        isRefetching && currentlyFetchingId === cartItem.product.productId ?
                                                                            <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center', padding: 7 }}>
                                                                                <Spinner animation="border" role="status" size='sm' style={{ width: 8, height: 8 }} />
                                                                            </div> :

                                                                            cartItem.product.unit != '-- None --' ?
                                                                                <p style={{ fontFamily: 'Poppins-Regular', margin: 0, textAlign: "center", }}>{cartItem.qty} {cartItem.product.unit}</p>
                                                                                :
                                                                                <p style={{ fontFamily: 'Poppins-Regular', margin: 0, textAlign: "center" }}>{cartItem.qty}</p>
                                                                    }
                                                                </div>

                                                                <div onClick={(e) => quantityPressed((index + 1), 'increment', cartItem.product.sRate, cartItem.productId, cartItem, e)} >
                                                                    <img src={Plus} size={14} />

                                                                </div>
                                                            </div>

                                                    }
                                                </td>

                                                <td>
                                                    {

                                                        cartItem.product.oRate == null ?
                                                            <div style={{ alignItems: 'center', }}>
                                                                {
                                                                    cartItem.product.sRate < (cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp) ?
                                                                        <div style={{}}>
                                                                            <p style={{ fontFamily: 'Roboto-medium', textDecorationLine: 'line-through', marginRight: 5, fontSize: 16, marginBottom: 0 }}>
                                                                                {currencySymbol} {(cartItem.product.mrp * cartItem.product.incrementValue).toFixed(2)}
                                                                            </p>
                                                                            <p style={{ fontFamily: 'Roboto-medium', fontSize: 20, color: '#FF0000', marginBottom: 0 }}>
                                                                                {currencySymbol} {(cartItem.product.sRate * cartItem.product.incrementValue).toFixed(2)}
                                                                            </p>

                                                                        </div>
                                                                        :

                                                                        <p style={{ fontFamily: 'Roboto-medium', fontSize: 20, color: '#FF0000', marginBottom: 0 }}>
                                                                            {currencySymbol} {(cartItem.product.sRate * cartItem.product.incrementValue).toFixed(2)}
                                                                        </p>
                                                                }
                                                                <p style={{ fontFamily: 'Poppins-Regular', fontSize: 10, fontWeight: 600, color: '#388E3C', margin: 0 }}>Excluding 18% GST</p>
                                                            </div>
                                                            :
                                                            <div style={{ alignItems: 'center' }}>
                                                                {
                                                                    cartItem.product.oRate < (cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp) ?
                                                                        <div style={{}}>
                                                                            <p style={{ fontFamily: 'Roboto-medium', textDecorationLine: 'line-through', marginRight: 5, fontSize: 16, marginBottom: 0 }}>
                                                                                {currencySymbol} {((cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp) * cartItem.product.incrementValue).toFixed(2)}
                                                                            </p>
                                                                            <p style={{ fontFamily: 'Roboto-medium', fontSize: 20, color: '#FF0000', marginBottom: 0 }}>
                                                                                {currencySymbol} {(cartItem.product.oRate * cartItem.product.incrementValue).toFixed(2)}
                                                                            </p>

                                                                        </div>
                                                                        :
                                                                        <p style={{ fontFamily: 'Roboto-medium', fontSize: 20, color: '#FF0000', marginBottom: 0 }}>
                                                                            {currencySymbol} {(cartItem.product.sRate * cartItem.product.incrementValue).toFixed(2)}
                                                                        </p>

                                                                }
                                                                <p style={{ fontFamily: 'Poppins-Regular', fontSize: 10, fontWeight: 600, color: '#388E3C', margin: 0 }}>Excluding 18% GST</p>
                                                            </div>


                                                    }
                                                </td>
                                                <td>
                                                    <div className='removeButtonWraper' onClick={(e) => removeItem(cartItem.productId, cartItem, e)}>
                                                        <img src={Trash} height={20} />
                                                    </div>
                                                </td>
                                            </tr>
                                            );
                                        })
                                    }

                                </tbody>
                            </table>
                        :
                        <div style={{ padding: '0 0.85rem 1rem', width: '100%', boxSizing: 'border-box' }}>

                            {
                                cartItems?.customerCartItems?.length === 0 ?
                                    <div style={{ alignItems: 'center', marginTop: 30, display: 'flex', justifyContent: 'center' }}>
                                        <p style={{ fontFamily: 'Poppins-Regular', color: '#666' }}>{language.noItmsLabe}</p>
                                    </div>
                                    :

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                        {
                                            cartItems.customerCartItems.map((cartItem, index) => {
                                                const prodId = cartItem.product?.productId || cartItem.productId;
                                                return (
                                                    <div
                                                        key={index}
                                                        className='cart-mobile-item'
                                                        onClick={() => {
                                                            if (prodId) {
                                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                navigate(`/Productdetails/${prodId}`);
                                                            }
                                                        }}
                                                    >
                                                        {/* Image */}
                                                        <div className='cart-mobile-item-img-container'>
                                                            <img
                                                                src={cartItem.product.tblProductImages ? cartItem.product.tblProductImages[0].image : null}
                                                                className='cart-mobile-item-image'
                                                                alt={cartItem.product.productName}
                                                            />
                                                        </div>

                                                    {/* Info */}
                                                    <div className='cart-mobile-item-info'>
                                                        {cartItem.product.brand?.brandName && (
                                                            <p style={{ fontFamily: 'Poppins-Regular', color: '#9E9E9E', fontSize: 10, margin: '0 0 2px 0' }}>{cartItem.product.brand?.brandName}</p>
                                                        )}
                                                        <p style={{ fontFamily: 'Poppins-Regular', margin: '0 0 4px 0', fontSize: 14, fontWeight: 600, color: '#212121', lineHeight: 1.3 }}>{cartItem.product?.productName}</p>
                                                        {cartItem.product.regionalLanguage && (
                                                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 12, margin: '0 0 4px 0', color: '#666' }}>{cartItem.product.regionalLanguage}</p>
                                                        )}
                                                        {
                                                            cartItem.product.isStockAvailable === false
                                                                ? <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 11, color: language.red, margin: '0 0 4px 0' }}>{language.outStockLabel}</p>
                                                                : <p style={{ fontFamily: 'BeVietnamPro-Regular', fontSize: 11, color: language.green, margin: '0 0 4px 0' }}>{language.inStockLabel}</p>
                                                        }

                                                        {/* Price */}
                                                        {
                                                            cartItem.product.oRate == null ?
                                                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                                                                    {
                                                                        cartItem.product.sRate < (cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp)
                                                                            ? <p style={{ fontFamily: 'Roboto-medium', textDecoration: 'line-through', fontSize: 13, color: '#BDBDBD', margin: 0 }}>
                                                                                {currencySymbol} {(cartItem.product.mrp * cartItem.product.incrementValue).toFixed(2)}
                                                                              </p>
                                                                            : null
                                                                    }
                                                                    <p style={{ fontFamily: 'Roboto-medium', fontSize: 16, fontWeight: 700, color: '#FF0000', margin: 0 }}>
                                                                        {currencySymbol} {(cartItem.product.sRate * cartItem.product.incrementValue).toFixed(2)}
                                                                    </p>
                                                                </div>
                                                                :
                                                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                                                                    {
                                                                        cartItem.product.oRate < (cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp)
                                                                            ? <p style={{ fontFamily: 'Roboto-medium', textDecoration: 'line-through', fontSize: 13, color: '#BDBDBD', margin: 0 }}>
                                                                                {currencySymbol} {((cartItem.product.mrp == null ? cartItem.product.sRate : cartItem.product.mrp) * cartItem.product.incrementValue).toFixed(2)}
                                                                              </p>
                                                                            : null
                                                                    }
                                                                    <p style={{ fontFamily: 'Roboto-medium', fontSize: 16, fontWeight: 700, color: '#FF0000', margin: 0 }}>
                                                                        {currencySymbol} {(cartItem.product.oRate * cartItem.product.incrementValue).toFixed(2)}
                                                                    </p>
                                                                </div>
                                                        }
                                                        <p style={{ fontFamily: 'Poppins-Regular', fontSize: 10, fontWeight: 600, color: '#388E3C', margin: '2px 0 8px 0' }}>Excluding 18% GST</p>

                                                        {/* Footer: qty stepper + delete */}
                                                        <div className='cart-mobile-item-footer' onClick={e => e.stopPropagation()}>
                                                            {
                                                                cartItem.product.isStockAvailable !== false &&
                                                                <div className='quantityWrapper'>
                                                                    <div className='qty-touch-btn' onClick={(e) => quantityPressed((index + 1), 'decrement', cartItem.product.sRate, cartItem.productId, cartItem, e)}>
                                                                        <img src={Minus} alt='-' style={{ width: 12, height: 12 }} />
                                                                    </div>
                                                                    <div style={{ textAlign: 'center', padding: '0 8px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        {
                                                                            isRefetching && currentlyFetchingId === cartItem.product.productId
                                                                                ? <Spinner animation="border" role="status" size='sm' style={{ width: 12, height: 12 }} />
                                                                                : <span style={{ fontFamily: 'Poppins-Regular', fontSize: 12, fontWeight: 600, color: '#222' }}>
                                                                                    {cartItem.qty}{cartItem.product.unit && cartItem.product.unit !== '-- None --' ? ` ${cartItem.product.unit}` : ''}
                                                                                  </span>
                                                                        }
                                                                    </div>
                                                                    <div className='qty-touch-btn' onClick={(e) => quantityPressed((index + 1), 'increment', cartItem.product.sRate, cartItem.productId, cartItem, e)}>
                                                                        <img src={Plus} alt='+' style={{ width: 12, height: 12 }} />
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className='removeButtonWraper' onClick={(e) => removeItem(cartItem.productId, cartItem, e)} title="Remove item">
                                                                <img src={Trash} height={16} alt='remove' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                );
                                            })
                                        }
                                    </div>

                            }

                        </div>
            }
            {
                totalValue > 0 ?
                    <div className='cart-page-total'>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 18, margin: 0, fontWeight: 600, color: '#1e293b' }}>Total</p>
                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11.5, color: '#16a34a', margin: 0, fontWeight: 500 }}>
                                Includes 18% GST ({currencySymbol} {(totalValue * 0.18).toFixed(decimalPlaces)})
                            </p>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
                            <p style={{ fontFamily: 'Montserrat-Medium', color: '#FF0000', fontSize: 20, margin: 0, fontWeight: 700 }}>
                                {currencySymbol} {(totalValue * 1.18).toFixed(decimalPlaces)}
                            </p>
                            <p style={{ fontFamily: 'Poppins-Regular', fontSize: 11, color: '#64748b', margin: 0 }}>
                                Base: {currencySymbol} {totalValue.toFixed(decimalPlaces)}
                            </p>
                        </div>
                    </div>
                    : null
            }
            {
                cartItems?.customerCartItems?.length > 0 ?
                    <div className="cart-place-order-wrapper">
                        <p className='cart-page-large-order-button' style={{ width: '100%', maxWidth: 380, textAlign: 'center' }} onClick={() => navigate('/Sharecatalogue')}>
                            Place Order
                        </p>
                    </div>
                    : null
            }
            <Snackbar
                open={snackopen}
                autoHideDuration={2000}
                onClose={onSnackClose}
                message={message}
                action={action}
                ContentProps={{
                    style: { backgroundColor: '#388E3C' } // ✅ Green
                }}
            />
        </div >
    )
}




